"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

var _WavePoint = _interopRequireDefault(require("@rsuite/icon-font/lib/charts/WavePoint"));

// Generated by script, don't edit it please.
var WavePoint = (0, _createSvgIcon["default"])({
  as: _WavePoint["default"],
  ariaLabel: 'wave point',
  category: 'charts',
  displayName: 'WavePoint'
});
var _default = WavePoint;
exports["default"] = _default;
module.exports = exports.default;